import Request from'./request';

export default class GitConfigService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new GitConfigService());
	}

	setGitConfigPush(git) {
		return Request.instance().post('/console/v1/git/config/push', git);
	}

	setGitConfigPull(git) {
		return Request.instance().post('/console/v1/git/config/pull', git);
	}

	setGitConfigConfirm(git) {
		return Request.instance().post('/console/v1/git/config/pull/confirm', git);
	}

	loadBranches(git) {
		return Request.instance().post('/console/v1/git/config/branches/list', git);
	}

    loadConfigurableServices() {
		return Request.instance().get('/console/v1/git/config/services');
	}

    loadLocal(git) {
		return Request.instance().post('/console/v1/git/config/local', git);
	}

    loadDiff(collectionName, serviceName, diff) {
		return Request.instance().post('/console/v1/git/config/diff/' + collectionName + '/' + serviceName, diff);
	}

	loadMetadata(serviceUrl) {
		return Request.instance().get(serviceUrl + '/export/metadata');
	}

	loadLocalSource(serviceUrl, folderName, fileName) {
		return Request.instance().post(serviceUrl + '/export/source/file', { name: fileName, folder: folderName });
	}

	loadRemoteSource(uuid, serviceId, folderName, fileName) {
		return Request.instance().post('/console/v1/git/config/file', { uuid, serviceId, fileName, folderName });
	}
}